"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutoringType = exports.HIDE_CUSTOM_TOKEN_BANNER_SEARCH_PARAM_KEY = exports.GoStudentEventTypes = exports.REACHED_OUT_VIA_DEFAULT = exports.TUTORING_LEAD_SOURCES = exports.senecaSubjectsList = exports.goStudentSupportedSubjectsEnglishToGerman = exports.SERVICE_NAME = void 0;
// Used by other services to reference this one in the dependency map
exports.SERVICE_NAME = 'tutoring-service';
exports.goStudentSupportedSubjectsEnglishToGerman = {
    Biology: 'Biologie',
    Business: 'Betriebswirtschaft',
    Chemistry: 'Chemie',
    Coding: 'Coding',
    'Computer Science': 'Informatik',
    Economics: 'Wirtschaft',
    English: 'Englisch',
    French: 'Französisch',
    Geography: 'Geografie',
    German: 'Deutsch',
    History: 'Geschichte',
    Latin: 'Latein',
    Mathematics: 'Mathematik',
    'Media Studies': 'Medien',
    Philosophy: 'Philosophie',
    Physics: 'Physik',
    Spanish: 'Spanisch',
    Other: 'Sonstiges'
};
exports.senecaSubjectsList = [
    ...Object.keys(exports.goStudentSupportedSubjectsEnglishToGerman),
    'Combined Science',
    'Design Technology',
    'Music',
    'Physical Education',
    'Political Studies',
    'Psychology',
    'Religious Studies',
    'Science',
    'Sociology'
].sort();
/**
 * New tutoring lead sources must be added to Seneca Sources enum in Hubspot
 */
var TUTORING_LEAD_SOURCES;
(function (TUTORING_LEAD_SOURCES) {
    TUTORING_LEAD_SOURCES["UNSET"] = "UNSET";
    TUTORING_LEAD_SOURCES["WHAT_IS_PREMIUM_PARENT"] = "WHAT_IS_PREMIUM_PARENT";
    TUTORING_LEAD_SOURCES["PARENT_AD"] = "PARENT_AD";
    TUTORING_LEAD_SOURCES["PARENT_MONITORING_TABLE"] = "PARENT_MONITORING_TABLE";
    TUTORING_LEAD_SOURCES["DIRECT_URL"] = "DIRECT_URL";
    TUTORING_LEAD_SOURCES["CONNECTION_JOURNEY_SECOND_MODAL"] = "CONNECTION_JOURNEY_SECOND_MODAL";
    TUTORING_LEAD_SOURCES["NAVBAR"] = "NAVBAR";
    TUTORING_LEAD_SOURCES["PARENT_SINGLE_ASSIGNMENT"] = "PARENT_SINGLE_ASSIGNMENT";
    TUTORING_LEAD_SOURCES["STUDENT_TEN_SESSIONS"] = "STUDENT_TEN_SESSIONS";
    TUTORING_LEAD_SOURCES["STATIC_SITE"] = "STATIC_SITE";
    TUTORING_LEAD_SOURCES["PARENT_WEEKLY_REPORT"] = "PARENT_WEEKLY_REPORT";
    TUTORING_LEAD_SOURCES["MARKETING_PREFERENCES_SECOND_MODAL"] = "MARKETING_PREFERENCES_SECOND_MODAL";
    TUTORING_LEAD_SOURCES["REVISION_NOTES"] = "REVISION_NOTES";
    TUTORING_LEAD_SOURCES["EMAIL_MARKETING"] = "EMAIL_MARKETING";
})(TUTORING_LEAD_SOURCES = exports.TUTORING_LEAD_SOURCES || (exports.TUTORING_LEAD_SOURCES = {}));
exports.REACHED_OUT_VIA_DEFAULT = 'UK/IE // Seneca';
var GoStudentEventTypes;
(function (GoStudentEventTypes) {
    GoStudentEventTypes["LINK_TUTORS_AND_TUTEES"] = "link-tutors-and-tutees";
    GoStudentEventTypes["UNLINK_TUTORS_AND_TUTEES"] = "unlink-tutors-and-tutees";
    GoStudentEventTypes["UNREGISTER_TUTORS"] = "unregister-tutors";
})(GoStudentEventTypes = exports.GoStudentEventTypes || (exports.GoStudentEventTypes = {}));
exports.HIDE_CUSTOM_TOKEN_BANNER_SEARCH_PARAM_KEY = 'hideCustomTokenBanner';
var TutoringType;
(function (TutoringType) {
    TutoringType["offline"] = "offline";
    TutoringType["online"] = "online";
    TutoringType["notSureYet"] = "not_sure_yet";
})(TutoringType = exports.TutoringType || (exports.TutoringType = {}));
//# sourceMappingURL=index.js.map